<template>
    <div class="card-box bg_load_null" v-pml-block="isLoading">
        <h4 class="header-title m-t-0 m-b-20 text-dark">{{ item.name }}</h4>
        <div class="row">
            <div class="col-xs-12 col-sm-6 m-b-15">
                <div ref="byMemberChart" v-show="hasMemberRegistry"></div>
                <pml-ec-pizza v-if="!hasMemberRegistry"></pml-ec-pizza>
            </div>

            <div class="col-xs-12 col-sm-6 m-b-15">
                <div ref="byStepChart" v-show="hasStepRegistry"></div>
                <pml-ec-pizza v-if="!hasStepRegistry"></pml-ec-pizza>
            </div>
        </div>
        <div class="over_auto table_no_margin">
            <table class="table table-striped table-bordered m-0">
                <thead>
                    <tr>
                        <th>{{$t('consultant')}}</th>
                        <th class="t_center" v-for="step in item.steps">{{ step.name }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(member, index) in byMember">
                        <td class="bold">{{ index | pmlMemberById }}</td>
                        <td class="t_center" v-for="step in item.steps">
                            {{ getAmount(index, step.id) }}
                        </td>
                    </tr>
                    <tr v-if="!dataCounter">
                        <td class="t_center" colspan="8"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import c3 from 'c3'
    import * as d3 from 'd3'
    import { getPipelineReport } from 'services/reports'
    import { groupBy, find } from 'lodash'

    export default {
        name: 'PipelineData',
        props: [ 'item' ],
        data () {
            return {
                data: {
                    by_member: [],
                    by_step: []
                },
                isLoading: false
            }
        },
        computed: {
            byMember () {
                return groupBy(this.data.by_member_step, 'member_id')
            },
            dataCounter () {
                return this.data.by_member_step ? this.data.by_member_step.length : 0
            },
            hasMemberRegistry () {
                return this.data.by_member.length !== 0
            },
            hasStepRegistry () {
                return this.data.by_step.length !== 0
            }
        },
        mounted () {
            this.isLoading = true
            getPipelineReport(this.item.id)
                .then(response => {
                    this.data = response.data

                    if (this.dataCounter)
                        this.buildChart()
                })
                .catch(() => {
                    // error
                })
                .then(() => {
                    this.isLoading = false
                })
        },
        methods: {
            getAmount (memberId, stepId) {
                const obj = find(this.data.by_member_step, { 'member_id': parseInt(memberId), 'pipeline_step_id': parseInt(stepId) })
                return obj ? obj.amount : 0
            },
            buildChart () {
                c3.generate({
                    bindto: this.$refs.byMemberChart,
                    data: {
                        columns: this.data.by_member,
                        type: 'pie'
                    },
                    pie: {
                        label: {
                            show: false
                        }
                    },
                    legend: {
                        position: 'right'
                    },
                    tooltip: {
                        format: {
                            value (value, ratio, id, index) {
                                return `&nbsp;${d3.format('.1%')(ratio)} (${value})`
                            }
                        }
                    }
                })

                c3.generate({
                    bindto: this.$refs.byStepChart,
                    data: {
                        columns: this.data.by_step,
                        type: 'pie'
                    },
                    pie: {
                        label: {
                            show: false
                        }
                    },
                    legend: {
                        position: 'right'
                    },
                    tooltip: {
                        format: {
                            value (value, ratio, id, index) {
                                return `&nbsp;${d3.format('.1%')(ratio)} (${value})`
                            }
                        }
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/pipelines/components/Pipeline.vue